/*fx.ns("desktop.book.edition", class TypeAlbum extends fx.Component{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;

        this.showEffect = "hslideout";
        this.hideEffect = "hslidein";
	}

	create()
	{
        this.backContainer = new fx.components.Box();
		this.backButton = new fx.components.IconButton( {icon: fx.get("assets").arrowBack} );
		let text = new fx.components.Text({text : fx.text("Thèmes"), className : "button-label link right-label"});
		this.backContainer.addChild(this.backButton, {width:40, height:40, left : 0, top : 0})
		this.backContainer.addChild(text, {width: 150, height : 20, top : 10, left : 40})
		this.addChild( this.backContainer, {top : 15, left : 15, width:150, height:40});

		if (this.data.creator.created)
		{
		    this.nextContainer = new fx.components.Box("back-container");
            this.nextButton = new fx.components.IconButton( {icon: fx.assets.arrowNext} );
            let text = new fx.components.Text({text : fx.text("Votre Album"), className : "button-label link"});
            this.nextContainer.addChild(text, {width: 150, height : 20, top : 10, left : -35})
            this.nextContainer.addChild(this.nextButton, {width:40, height:40, left : 110, top : 0})
            this.addChild( this.nextContainer, {top : 15, right : 15, width:150, height:40});
		}

		this.typeAlbumContainer = new fx.components.Box();


	}

    onReady()
    {
        super.onReady();

        this.on("click", this._onBack, this.backContainer);

		if (this.nextContainer)
			this.on("click", this._onNext, this.nextContainer);

        this.on("click", this._onClick, this.typeAlbumContainer);
        
		this.albums = this.data.creator.albums();

		if (this.albums.length == 1)
		{
			this.data.creator.selectedAlbum = this.albums[0];
			this.data.event("next-step");
		}
		else
			this.buildAlbums(this.albums);
    }

	buildAlbums(albums)
	{
		this.title = new fx.components.Text({text :fx.text("Choisissez votre album en fonction de votre budget"), className : "title center"});
		this.typeAlbumContainer.addChild(this.title, {width:"100%", height : 40, top : 0, left : "center"});

        //let albums = this.data.creator.albums();

		let containerCategories = new fx.components.HBox("center"); 
	
		for (let i = 0; i < albums.length; i++)
			containerCategories.addChild( new shared.renderers.AlbumRenderer(albums.getItemAt(i)), {width : 180, height : 300});
		
		this.typeAlbumContainer.addChild(containerCategories, {width:"100%", height : 200, top : 80, left : "center"});
		
		this.addChild(this.typeAlbumContainer, { width : 800, height : 430, top : "center", left : "center"});
	}

    _onBack()
    {
		this.hideEffect = "hslideout";

        this.data.event("previous-step");
    }

	_onNext()
	{
		this.data.event("next-Preview");
	}

	_onClick(event)
    {
		let target = this.getChildFromUI(fx.dom.parent(event.target, ".AlbumRenderer"));
		
		if(target)
		{
			this.data.creator.selectedAlbum = target.data;
			this.data.event("next-step");
		}
    }
    

});

	*/